// AquaX product pages: option chips drive the real Shopify product form
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
document.documentElement.classList.add('js');
const variants = JSON.parse($('#aqx-variants').textContent);
const form = $('#aqx-form');
const input = $('[data-variant-input]');
const priceEl = $('[data-price]');
const label = $('[data-label]');
const fmt = c => '฿' + Math.round(c / 100).toLocaleString('en-US');
let current = variants.find(v => String(v.id) === input.value) || variants[0];
const chosen = current.options.slice();
function apply(animate) {
  const v = variants.find(x => x.options.every((o, i) => o === chosen[i]));
  if (!v) return;
  current = v; input.value = v.id;
  priceEl.textContent = fmt(v.price);
  if (animate) { priceEl.classList.remove('swap'); void priceEl.offsetWidth; priceEl.classList.add('swap'); }
  label.textContent = 'Book ' + v.title.replace(' / ', ', ');
  $$('.chip[data-opt]').forEach(b => { const on = chosen[+b.dataset.opt] === b.dataset.val; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
  $$('.price-table tr').forEach(tr => tr.classList.toggle('is-on', tr.dataset.row === String(v.id)));
  const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
}
$$('.chip[data-opt]').forEach(b => b.addEventListener('click', () => { chosen[+b.dataset.opt] = b.dataset.val; apply(true); }));
apply(false);

// day and time: Phuket dates only, no times already gone today
const dateIn = $('[data-date]'), timeIn = $('[data-time]'), note = $('[data-when-note]');
const bkk = d => new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Bangkok', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
const today = bkk(new Date());
dateIn.min = today; dateIn.max = bkk(new Date(Date.now() + 180 * 864e5));
function slots() {
  const now = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Bangkok', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date());
  $$('option', timeIn).forEach(o => { if (o.value) o.disabled = dateIn.value === today && o.value <= now; });
  if (timeIn.selectedOptions[0]?.disabled) timeIn.value = '';
}
const dateOut = $('[data-date-out]');
const noteText = note.textContent;
function settle(el) {
  el.closest('.pdp-field').classList.remove('is-missing');
  if (!$('.pdp-when .is-missing')) { note.textContent = noteText; note.classList.remove('is-alert'); }
}
dateIn.addEventListener('change', () => { slots(); settle(dateIn); });
timeIn.addEventListener('change', () => settle(timeIn));
// the order shows "Fri 20 Nov 2026", not 2026-11-20
const nice = v => new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(v + 'T12:00:00Z')).replace(',', '');
addEventListener('pageshow', () => { dateIn.name = 'properties[Date]'; dateOut.removeAttribute('name'); });
form.addEventListener('submit', e => {
  slots();
  const okDate = dateIn.value && dateIn.value >= dateIn.min && dateIn.value <= dateIn.max;
  const miss = [[dateIn, !okDate], [timeIn, !timeIn.value]].filter(([, bad]) => bad).map(([el]) => el);
  miss.forEach(el => el.closest('.pdp-field').classList.add('is-missing'));
  if (miss.length) { e.preventDefault(); note.textContent = 'Choose a day and a time to book.'; note.classList.add('is-alert'); miss[0].focus(); }
  else { dateOut.value = nice(dateIn.value); dateOut.name = 'properties[Date]'; dateIn.removeAttribute('name'); }
});

// nav ink over light fields
function navInk() {
  const probe = document.elementsFromPoint(innerWidth * 0.5, 34).find(el => !el.closest('.bar, .bar-mark'));
  document.body.classList.toggle('on-light', !!(probe && probe.closest('.kit, .pdp-prices, .foot')));
}
// entrances: hidden only just before they come up from below
const rise = [];
[['.pdp-story', ['h2', '.diag > *']], ['.pdp-kit', ['h2', 'tr']], ['.pdp-specs', ['h2', 'li', '.spec-note']], ['.pdp-prices', ['h2', 'tr']], ['.faq', ['h2', 'details']], ['.pdp-more', ['h2', '.panel']], ['.meet', ['h2', '.meet-lead', '.meet .btn', '.meet-map']], ['.foot', ['.foot-cols > div', '.foot-mark']]]
  .forEach(([sec, sels]) => { const root = $(sec); if (!root) return; let i = 0; sels.forEach(s => $$(s, root).forEach(el => { el.dataset.rise = ''; el.style.setProperty('--i', Math.min(i++, 8)); rise.push(el); })); });
function riseTick() {
  const vh = innerHeight;
  for (const el of rise) {
    if (el.dataset.done) continue;
    const t = el.getBoundingClientRect().top;
    if (el.classList.contains('pre')) { if (t < vh * 0.92) { el.classList.add('in'); el.dataset.done = 1; } else if (t > vh * 2.4 || t < 0) el.classList.remove('pre'); }
    else if (t > vh * 1.02 && t < vh * 2.2) el.classList.add('pre');
    else if (t < vh) el.dataset.done = 1;
  }
}
addEventListener('scroll', () => requestAnimationFrame(() => { riseTick(); navInk(); }), { passive: true });
riseTick(); navInk();
// footer wordmark fitted to the width
const mark = $('.foot-mark');
function fitMark() {
  mark.style.fontSize = '100px';
  const w = mark.getBoundingClientRect().width, avail = document.documentElement.clientWidth - 2 * parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--m') || 28);
  mark.style.fontSize = (100 * avail / w).toFixed(2) + 'px';
}
document.fonts.ready.then(fitMark); addEventListener('resize', fitMark);
